function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "scale(.26718)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 950,
  cy: 950,
  r: 950,
  fill: "#7d2ae7"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 950,
  cy: 950,
  r: 950,
  fill: "url(#canva_svg__prefix___Radial1)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 950,
  cy: 950,
  r: 950,
  fill: "url(#canva_svg__prefix___Radial2)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 950,
  cy: 950,
  r: 950,
  fill: "url(#canva_svg__prefix___Radial3)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 950,
  cy: 950,
  r: 950,
  fill: "url(#canva_svg__prefix___Radial4)"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M446.744 276.845c-.665 0-1.271.43-1.584 1.33-4.011 11.446-9.43 18.254-13.891 18.254-2.563 0-3.6-2.856-3.6-7.336 0-11.21 6.71-34.982 10.095-45.82.392-1.312.646-2.485.646-3.483 0-3.15-1.722-4.696-5.987-4.696-4.598 0-9.547 1.8-14.36 10.233-1.663-7.435-6.691-10.683-13.715-10.683-8.12 0-15.965 5.224-22.421 13.696-6.456 8.471-14.048 11.25-19.76 9.88 4.108-10.057 5.634-17.57 5.634-23.145 0-8.746-4.324-14.028-11.308-14.028-10.624 0-16.747 10.134-16.747 20.797 0 8.237 3.736 16.708 11.954 20.817-6.887 15.573-16.943 29.66-20.758 29.66-4.93 0-6.379-24.123-6.105-41.38.176-9.9.998-10.408.998-13.401 0-1.722-1.115-2.896-5.595-2.896-10.448 0-13.676 8.844-14.165 18.998a50.052 50.052 0 01-1.8 11.406c-4.363 15.573-13.363 27.39-19.232 27.39-2.72 0-3.463-2.72-3.463-6.28 0-11.21 6.28-25.219 6.28-37.173 0-8.784-3.854-14.34-11.112-14.34-8.55 0-19.858 10.173-30.56 29.229 3.521-14.595 4.97-28.721-5.459-28.721a14.115 14.115 0 00-6.476 1.683 3.689 3.689 0 00-2.113 3.56c.998 15.535-12.521 55.329-25.336 55.329-2.328 0-3.463-2.524-3.463-6.593 0-11.23 6.691-34.943 10.056-45.801.43-1.409.666-2.622.666-3.678 0-2.974-1.84-4.5-6.007-4.5-4.578 0-9.547 1.741-14.34 10.174-1.683-7.435-6.711-10.683-13.735-10.683-11.523 0-24.397 12.19-30.051 28.076-7.572 21.208-22.832 41.692-43.375 41.692-18.645 0-28.486-15.515-28.486-40.03 0-35.392 25.982-64.308 45.253-64.308 9.215 0 13.617 5.869 13.617 14.869 0 10.897-6.085 15.964-6.085 20.112 0 1.272 1.057 2.524 3.15 2.524 8.374 0 18.234-9.841 18.234-23.262 0-13.422-10.897-23.243-30.168-23.243-31.851 0-63.898 32.047-63.898 73.113 0 32.673 16.121 52.374 44 52.374 19.017 0 35.628-14.79 44.588-32.047 1.018 14.302 7.513 21.776 17.413 21.776 8.804 0 15.925-5.243 21.364-14.458 2.094 9.645 7.65 14.36 14.87 14.36 8.275 0 15.201-5.243 21.794-14.986-.097 7.65 1.644 14.85 8.276 14.85 3.13 0 6.867-.725 7.533-3.464 6.984-28.877 24.24-52.453 29.523-52.453 1.565 0 1.995 1.507 1.995 3.287 0 7.846-5.537 23.928-5.537 34.2 0 11.092 4.716 18.43 14.459 18.43 10.8 0 21.775-13.227 29.092-32.556 2.29 18.058 7.24 32.633 14.987 32.633 9.508 0 26.392-20.014 36.625-41.203 4.01.509 10.036.372 15.827-3.717-2.465 6.241-3.912 13.07-3.912 19.897 0 19.663 9.39 25.18 17.47 25.18 8.785 0 15.907-5.243 21.365-14.458 1.8 8.315 6.398 14.34 14.85 14.34 13.225 0 24.71-13.519 24.71-24.612 0-2.934-1.252-4.715-2.72-4.715zm-274.51 18.547c-5.342 0-7.435-5.38-7.435-13.401 0-13.93 9.528-37.193 19.604-37.193 4.402 0 6.065 5.185 6.065 11.524 0 14.145-9.059 39.07-18.235 39.07zm182.948-41.574c-3.189-3.796-4.343-8.961-4.343-13.559 0-5.673 2.074-10.467 4.558-10.467 2.485 0 3.248 2.446 3.248 5.85 0 5.693-2.035 14.008-3.463 18.176zm41.418 41.574c-5.34 0-7.434-6.182-7.434-13.401 0-13.441 9.528-37.193 19.682-37.193 4.402 0 5.967 5.146 5.967 11.524 0 14.145-8.902 39.07-18.215 39.07z",
  fill: "#fff",
  fillRule: "nonzero"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "canva_svg__prefix___Radial1",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(-49.416 2013.203 443.786) scale(1469.491)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6420ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6420ff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "canva_svg__prefix___Radial2",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(54.703 42.717 594.194) scale(1657.122)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c4cc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00c4cc",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "canva_svg__prefix___Radial3",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(1023 -1030 473.711 470.491 367 1684)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6420ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6420ff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "canva_svg__prefix___Radial4",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(595.999 1372 -2298.41 998.431 777 256)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c4cc",
  stopOpacity: 0.73
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c4cc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00c4cc",
  stopOpacity: 0
})));

var SvgCanva = function SvgCanva(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 508 508",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref, _ref2, _ref3);
};

export default SvgCanva;